import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IsArrayPipe } from './is-array.pipe';

@NgModule({
  declarations: [
    IsArrayPipe
  ],
  exports: [
    IsArrayPipe
  ],
  imports: [
    CommonModule
  ]
})
export class IsArrayModule { }
